<template>
  <div class="ctrl-button-toggle" :style="{ 'width': width + 'px' }">
    <a
        @click="toggleIsOpen"
        class="ctrl-button">
      {{ selectedName }}
      <span style="float: right">
        <i data-icon="arrow-down-white" class="icon"></i>
      </span>
    </a>
    <div class="ctrl-select-options" v-if="isOpen" :style="{ 'width': width + 'px' }">
      <div>
        <div
          role="option"
          @click="selectionChanged(null)"
          class="ctrl-select-option">Tilføj opgave</div>
        <div v-for="obj of sourceList" v-bind:key="keyPropertyName(obj)"
          role="option"
          @click="selectionChanged(obj)"
          class="ctrl-select-option">{{ displayPropertyName(obj) }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GroupDropdown',
  props: {
    sourceList: {
      type: Array,
    },
    keyPropertyName: {
      type: Function,
    },
    displayPropertyName: {
      type: Function,
    },
    placeholder: {
      type: String,      
    },
    selectedValue: {
      type: String,
      default: null,
    },
    width: {
      type: Number,
      default: 295,
    },
  },
  data() {
    return {
      isOpen: false,
      selectedObject: null,
    };
  },
  mounted() {
    if(this.selectedValue && this.sourceList) {
      for (let i = 0; i < this.sourceList.length; i++) {
        if(this.keyPropertyName(this.sourceList[i]) === this.selectedValue) {
          this.selectedObject = this.sourceList[i];          
        }
      }
    }
  },
  methods: {
    toggleIsOpen() {
      this.isOpen = !this.isOpen;
    },
    selectionChanged(obj) {
      this.selectedObject = obj;
      this.$emit('selectionChanged', (obj ? this.keyPropertyName(obj) : null));
      this.isOpen = false;
    },
    focussed() {
      this.isOpen = true;
    },
    blurred() {
      setTimeout(() => {
        this.isOpen = false;
      }, 200);
    },
  },
  computed: {
    selectedName() {
      return (this.selectedObject ? this.displayPropertyName(this.selectedObject) : 'Tilføj opgave');
    }
  },
}
</script>
<style lang="scss" scoped>
.ctrl-button {
  position: relative;
  margin: 0;
  width: 148px;
  background: $secondary;
  // background: -webkit-linear-gradient(#fff, #eee);
  // background: linear-gradient(#fff, #eee);
  border: 1px solid #bbb;
  // border-radius: 3px;
  color: $white;
  cursor: pointer;
  display: inline-block;
  font-size: 14px;
  font-weight: 500;
  line-height: 27px;
  text-decoration: none;
  // width: calc(100% - 10px);
  height: 30px;
  text-align: left; 
  padding-left:10px;
  
  &.is-active,
  &:active {
    background: rgba(0, 0, 0, 0.05);
    border-color: #aaa;
    box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.1);
    cursor: default;
    z-index: 1;
  }

  .icon {
    background-position: center;
    background-size: 17px;
    -webkit-box-sizing: content-box;
    box-sizing: content-box;
    height: 17px;
    opacity: 0.5;
    padding: 5px 10px;
    vertical-align: top;
    width: 17px;
  }
}
.icon[data-icon="arrow-down"] {
  background-image: url(data:image/svg+xml;base64,PHN2ZyBoZWlnaHQ9IjE4IiB3aWR0aD0iMTgiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0ibTkgMTAuMS00LjktNS0xLjUgMS40IDUgNSAxLjQgMS40IDEuNC0xLjQgNS01LTEuNS0xLjR6Ii8+PC9zdmc+);
}
.ctrl-select-options {
  background: #fff;
  border: 1px solid #bbb;
  border-radius: 4px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  font-size: 13px;
  font-weight: 500;
  margin-top: 2px;
  max-height: 260px;
  overflow-x: hidden;
  overflow-y: auto;
  padding: 5px 0;
  position: absolute;
  text-align: left;
  white-space: normal;
  max-width: 295px;
  z-index: 6;
}
.ctrl-select-options hr {
  margin: 5px 0;
}
.ctrl-select-options .button {
  display: block;
  margin: 12px 12px 7px;
  width: calc(100% - 24px);
}
.ctrl-select-group-label {
  cursor: default;
  font-size: 14px;
  font-weight: 600;
  padding: 8px 25px 8px 15px;
}
.ctrl-select-option {
  cursor: pointer;
  padding: 9px 25px 8px 15px;
}
.ctrl-select-option:hover {
  background: #f3f3f3;
}
.ctrl-select-option.is-active {
  background: #336bab;
  color: #fff;
}
.ctrl-select-option.is-active:active {
  background: #1a59a1;
}
</style>